(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RoomCostDeleteController',RoomCostDeleteController);

    RoomCostDeleteController.$inject = ['$uibModalInstance', 'entity', 'RoomCost'];

    function RoomCostDeleteController($uibModalInstance, entity, RoomCost) {
        var vm = this;
        vm.roomCost = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RoomCost.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
